import { render } from "./Embeds.vue?vue&type=template&id=6cc56598"
import script from "./Embeds.vue?vue&type=script&lang=js"
export * from "./Embeds.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__